import client from './client';

interface CartAddonClickPayload {
    menuItemId: number;
    slotPosition: number;
    userId: number | null;
    storeLocationId: number | null;
    /**
     * JSAD-6595: ties this click to the order that follows it. Deliberately
     * snake_case next to the camelCase four — new fields follow the wire
     * convention and renaming the existing ones would break shipped apps.
     * Must match ^[A-Za-z0-9-]{1,64}$ (a bare UUID v4) — anything else is
     * silently dropped server-side and the click loses attribution.
     */
    cart_correlation_id?: string;
}

export const trackCartAddonClick = async (payload: CartAddonClickPayload) => {
    return client.post('/v2/analytics/cart-addon-click', payload);
};

export default {
    trackCartAddonClick
};
